// extracted by css-extract-rspack-plugin
export default {"buttons":"IWhYsWpjS9813aH2__buttons___"};